import {
  EMBEDDED_GOODPUP_LINK,
  GOODPUP_LINK,
} from '@rover/react-lib/src/constants/training.constants';
import getUserAgentFlags from '@rover/shared/js/utils/getUserAgentFlags';

export const useGoodPupLink = (showGoodPupEmbeddedWebLink: boolean, tags?: string | null): URL => {
  const flags = getUserAgentFlags();
  if (showGoodPupEmbeddedWebLink && flags.isEmbedded) return new URL(EMBEDDED_GOODPUP_LINK);

  const link = new URL(GOODPUP_LINK);
  if (tags) {
    link.searchParams.set('tags', tags);
  }
  return link;
};
